import { Typography } from "@mui/joy";
import React, { useEffect, useState } from "react";
import useApiService from "../../../hooks/useApiService";
import { ClientRecord } from "../../../models/ClientInfo";
import { RouteComponentProps } from "../../../models/RouteComponent";
import styles from "../client.module.css";
import { Card } from "primereact/card";
import { Input } from "../../../components/Shared/Forms";
import { Button } from "primereact/button";
import ButtonPanel from "../../../components/Shared/ButtonPanel";
import { useToast } from "../../../context/ToastContext";

type formDataType = {
  vat_registration_number?: string | null;
  company_registration_number?: string | null;
  fund_registration_number?: string | null;
};

function RegistrationDetails(props: RouteComponentProps) {
  const { session } = props;
  const toast = useToast();
  const [clientRecord, setClientRecord] = useState<ClientRecord>();
  const [formData, setFormData] = useState<formDataType>({
    vat_registration_number: "",
    company_registration_number: "",
    fund_registration_number: "",
  });
  const [somethingChanged, setSomethingChanged] = useState<boolean>(false);

  const { loading: loadingClient, invalidate } = useApiService<ClientRecord>({
    url: `client/${session.client_id}`,
    method: "GET",
    apiName: "core",
    onSuccess: data => {
      setClientRecord(data);
      setFormData(prev => ({
        ...prev,
        vat_registration_number: data.vat_registration_number,
        company_registration_number: data.company_registration_number,
        fund_registration_number: data.fund_registration_number,
      }));
    },
    cache: { enabled: true, strategy: "cache-first", ttlMs: 5 * 60_000 },
  });

  const { loading: updatingClient, fetchData: updateClient } = useApiService<ClientRecord>({
    fetchOnMount: false,
    url: `client/${session.client_id}`,
    method: "PUT",
    apiName: "core",
    onSuccess: data => {
      setSomethingChanged(false);
      setClientRecord(prev => ({
        ...prev,
        ...data,
      }));
      invalidate();
      toast("success", "Client record successfully updated");
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loadingClient);
  }, [loadingClient]);

  async function handleSave() {
    let formValues: any = {
      ...formData,
    };

    let updateObject = {
      ...clientRecord,
      ...formValues,
    };

    delete updateObject.consultant_name;
    delete updateObject.industry_list;
    delete updateObject.updated_at;
    delete updateObject.created_at;
    delete updateObject.photo;
    delete updateObject.deleted_at;

    await updateClient({
      payload: updateObject,
    });
  }

  return (
    <div>
      <Typography level="h2" component="h1">
        General Details
      </Typography>
      <Card>
        <div className={styles["responsive-grid-2"]}>
          <Input
            label={"VAT Registration Number"}
            name={"vat_registration_number"}
            value={formData.vat_registration_number ?? ""}
            onChange={e => {
              setSomethingChanged(true);
              setFormData(prev => ({
                ...prev,
                vat_registration_number: e.target.value,
              }));
            }}
            placeholder={"Eg. 20123456789"}
          />
          <Input
            label={"Company Registration Number"}
            name={"company_registration_number"}
            placeholder={"Eg. 20123456789"}
            value={formData.company_registration_number ?? ""}
            onChange={e => {
              setSomethingChanged(true);
              setFormData(prev => ({
                ...prev,
                company_registration_number: e.target.value,
              }));
            }}
          />
          <Input
            label={"Compensation Fund Registration Number (Letter of good standing)"}
            name={"fund_registration_number"}
            value={formData.fund_registration_number ?? ""}
            placeholder={"Registration number"}
            onChange={e => {
              setSomethingChanged(true);
              setFormData(prev => ({
                ...prev,
                fund_registration_number: e.target.value,
              }));
            }}
          />
        </div>
      </Card>
      <ButtonPanel inModal={false}>
        <Button
          label={"Cancel"}
          outlined={true}
          disabled={!somethingChanged || updatingClient}
          // onClick={cancelChanges}
        />
        <Button
          label={"Save"}
          loading={updatingClient}
          disabled={!somethingChanged}
          onClick={async () => {
            await handleSave();
          }}
        />
      </ButtonPanel>
    </div>
  );
}

export default RegistrationDetails;
